<template>
    <div>
        <login-template :loading="state.loading">
            <template #form-title> Login To Your Account</template>
            <template #form-paragraph>Use provided credentials to log into your account</template>
            <template #form-section>
                <ScaleLoader v-if="state.loader || ssoAuth.loader" />
                <div v-if="state.otpMode" class="p-fluid">
                    <div class="field">
                        <base-text-input v-model="state.user.mail_otp" placeholder="Enter your OTP here" />
                    </div>
                </div>
                <div class="p-fluid" v-if="!ssoAuth.showLoginFields && !ssoAuth.loader">
                    <input v-model="ssoAuth.email" type="email" placeholder="Enter your email" class="p-inputtext p-component" />
                    <Button label="LOGIN" @click.prevent="ssoAuth.checkSSO()" type="button" class="mt-2" :disabled="ssoAuth.loader" />
                </div>
                <p v-if="ssoAuth.loader" class="mt-2 text-center">Redirecting to Microsoft…</p>

                <!-- Show login form only if SSO is unavailable -->
                <div class="p-fluid" v-if="ssoAuth.showLoginFields">
                    <div class="field">
                        <base-text-input v-model="state.user.email" type="email" placeholder="Email" @keyup.enter="loginUser" :errorMessage="formErrors.email" />
                    </div>
                    <div class="field">
                        <base-text-input v-model="state.user.password" type="password" placeholder="Password" @keyup.enter="loginUser" :errorMessage="formErrors.password" />
                    </div>
                    <Button label="LOGIN" type="button" @click.prevent="loginUser" :disabled="state.otpModeGodUser"/>
                    <!-- God User OTP -->
                   <div class="mt-2 flex justify-content-between"></div>

                    <div class="" v-if="state.otpModeGodUser">
                        <div class="field" >
                            <base-text-input v-model="state.user.god_user_otp" placeholder="Enter OTP" />
                        </div>
                        <Button  label="Verify OTP" type="button" @click.prevent="verifyOtp" />
                    </div>

                    <div  class="mt-2 flex justify-content-between">
                        <p class="mt-2">
                            <a href="" @click.prevent="ssoAuth.showLoginFields = false">Use Single Sign-On</a>
                        </p>
                        <p class="mt-2">
                            <a href="" @click.prevent="forgotPassword">Forgot Password</a>
                        </p>
                    </div>

                </div>

            </template>
        </login-template>
    </div>
</template>

<script setup>
import LoginTemplate from '../components/LoginTemplate';
import BaseTextInput from '../../custom-inputs/BaseTextInput.vue';

import { reactive, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { storeToRefs } from 'pinia';

import { authStore, formErrorStore, ssoAuth } from '../../../store/global-stores';
import { LoginSchema, handleErrors } from '../../../utilities/schemas';
import { showToast } from '../../../utilities/toast-handler';
import { purgeAmsClientState } from '@/modules/sso/utils/ssoTelemetry';

const router = useRouter();
const { formErrors } = storeToRefs(formErrorStore);


const state = reactive({
    user: {
        email: '',
        password: '',
        mail_otp: null,
        god_user_otp: null,
    },
    otpMode: false,
    otpModeGodUser: false,
    submitted: false,
    loader: false,
});

// Fresh login screen: reset Pinia first, then wipe origin localStorage/sessionStorage.
onMounted(() => {
    purgeAmsClientState(authStore, ssoAuth);
});

const loginUser = async () => {
    // initiate the loader and submit
    state.loader = true;
    state.submitted = true;
    await handleValidation(LoginSchema);
    // if validation success then submit
    const response = await authStore.login(state.user);
    // if god user otp is enabled
    if (response?.otpGS) {
        state.otpModeGodUser = true;
    }
    // if otp is enabled
    if (response?.otp) {
        state.otpMode = true;
    }
    state.loader = false;
};

const verifyOtp = async () => {
     await authStore.verifyOtp(state.user);
};

const handleValidation = async (schema) => {
    try {
        // validate the schema first
        await schema.validate({ ...state.user }, { abortEarly: false });
        formErrorStore.clearErrors();
    } catch (error) {
        if (error.inner && typeof error.inner === 'object') {
            const errors = handleErrors(error);
            formErrorStore.addErrors(errors);
            showToast({}, 'Input data invalid');
        }
    }
};

const forgotPassword = () => {
    router.push({ name: 'ForgotPassword' });
};

</script>
